import { Button, DatePicker, Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { EmployeeOfficeInformationUpdate, loadSingleStaff} from "../../../redux/rtk/features/user/userSlice";
import BtnEditSvg from "../Button/btnEditSvg";

const EmployeeEditPopup = ({ userId, user }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();

  // Prefill form data when modal opens
  useEffect(() => {
    if (isModalOpen && user) {
      form.setFieldsValue({
        OfficialMailId: user.OfficialMailId || "",
        EmployeeCode: user.EmployeeCode || "",
        JoinDate: user.JoinDate ? dayjs(user.JoinDate) : null,
        ProbationComplateDate: user.ProbationComplateDate ? dayjs(user.ProbationComplateDate) : null,
        EsicNumber: user.EsicNumber || "",
        UanNumber: user.UanNumber || "",
      });
    }
  }, [isModalOpen, user, form]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    const payload = {
      OfficialMailId: values.OfficialMailId || "",
      EmployeeCode: values.EmployeeCode || "",
      JoinDate: values.JoinDate ? values.JoinDate.format("YYYY-MM-DD") : null,
      ProbationComplateDate: values.ProbationComplateDate
        ? values.ProbationComplateDate.format("YYYY-MM-DD")
        : null,
      EsicNumber: values.EsicNumber || "",
      UanNumber: values.UanNumber || "",
      EmployeeId: user.EmployeeId || "",
      DataStatus: 1,
      EmploymentTypeId: user.EmploymentTypeId || 0,
      ReportingToId: user.ReportingToId || "0",
      GradeTypeId: user.GradeTypeId || 0,
      DepartmentId: user.DepartmentId || 0,
      DesignationId: user.DesignationId || 0,
      ShiftId: user.ShiftId || 0,
      LeavePolicyId: user.LeavePolicyId || 0,
      WeeklyWorkingDaysId: user.WeeklyWorkingDaysId || 0,
      IsPfDeducted: user.IsPfDeducted || false,
      IsEsicDeducted: user.IsEsicDeducted || false,
      RoleId: user.RoleId || "0",
      CompanyOfficeId: user.CompanyOfficeId || "0",
      PaymentTypeId: user.PaymentTypeId || 0,
    };
  
    // console.log("Payload:", payload); // Log the final payload
  
    try {
      const response = await dispatch(
        EmployeeOfficeInformationUpdate({ values: payload })
      );
      if (response.payload.message === "success") {
        toast.success("Employee details updated successfully!");
        dispatch(loadSingleStaff(id));
        setIsModalOpen(false);
        form.resetFields();
      } else if (response.payload.message === "error") {
        // Handle API error messages
        if (response.payload.data && Array.isArray(response.payload.data)) {
          const errorData = response.payload.data[0];
          if (errorData.message) {
            toast.error(errorData.message);
          } else {
            toast.error("Failed to update employee details");
          }
        } else {
          toast.error("Failed to update employee details");
        }
      }
    } catch (error) {
      // console.error("Error updating employee details:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };
  return (
    <>
      <button onClick={showModal}>
        <BtnEditSvg size={30} />
      </button>
      <Modal
        title="Update Employee Details"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="employeeDetails"
          layout="vertical"
          onFinish={onFinish}
        >
         

          <Form.Item
            label="Employee Code"
            name="EmployeeCode"
            rules={[
              { required: true, message: "Please input Employee Code!" },
            ]}
          >
            <Input placeholder="Enter employee code" />
          </Form.Item>

          <Form.Item
            label="Official Email ID"
            name="OfficialMailId"
            // rules={[
            //   { required: true, message: "Please enter the official email!" },
            //   { type: "email", message: "Please enter a valid email!" },
            // ]}
          >
            <Input placeholder="Enter official email" />
          </Form.Item>
          <Form.Item
            label="Join Date"
            name="JoinDate"
            rules={[{ required: true, message: "Please select the join date!" }]}
          >
            <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            label="Probation Completion Date"
            name="ProbationComplateDate"
           // rules={[{ required: true, message: "Please select the probation completion date!" }]}
          >
            <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            label="ESIC Number"
            name="EsicNumber"
          >
            <Input placeholder="Enter ESIC number" />
          </Form.Item>

          <Form.Item
            label="UAN Number"
            name="UanNumber"
          >
            <Input placeholder="Enter UAN number" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EmployeeEditPopup;